<p-sidebar
  #sidebar
  [visible]="(gridService.filtersPanel$ | async) === 'open'"
  [styleClass]="styleClass"
  [dismissible]="false"
  [blockScroll]="true"
  [closeOnEscape]="false"
  appendTo="body"
  (onHide)="onHide($event)"
>
  <h1 class="z-sidebar-title"><i class="{{ icon }}"></i> {{ title }}</h1>

  <div class="z-sidebar-controls p-fluid grid">
    <div class="col-6">
      <ng-content select="[left-button]"></ng-content>
    </div>

    <div class="col-6">
      <ng-content select="[right-button]"></ng-content>
    </div>
  </div>

  <div class="z-sidebar-content">
    <p-scrollPanel [style]="{ width: '100%', height: 'calc(100vh - 8.5rem)' }" styleClass="sidebar-scrollPanel">
      <ng-content></ng-content>
    </p-scrollPanel>
  </div>
</p-sidebar>
